export default __webpack_public_path__ + "static/media/installation-video-ios-EN.79b05d06.mp4";